import axios from "axios";
// import { store } from "@/store/store";
// import { config } from "@/config/config";

export default () => {
  return axios.create({
    baseURL: process.env.NODE_ENV === "production"
    ? `${process.env.VUE_APP_JTI_MANUAL_AGGREGATE_SERVICE}/${process.env.VUE_APP_JTI_MANUAL_AGGREGATE_SERVICE_PROXY}`
    : `${process.env.VUE_APP_JTI_MANUAL_AGGREGATE_SERVICE}:${process.env.VUE_APP_JTI_MANUAL_AGGREGATE_SERVICE_PORT}`,
    headers: {
      "Content-Type": `application/json`,
    //   Authorization: `Bearer ${process.env.VUE_APP_JTI_CMT_CREDIT_REGISTRATION_SERVICE_TOKEN}`,
    },
  });
};
